import { Injectable } from "@angular/core";
import { LorenBaseEndpointsService } from "../loren-base-endpoints-service/loren-base-endpoints.service";
import { LorenImageSize } from "../loren-image-service/enums/loren-image-size.enum";

@Injectable({
  providedIn: "root",
})
export class LorenImageEndpointsService extends LorenBaseEndpointsService {
  constructor() {
    super();
  }

  getImage(guid: string, size: LorenImageSize) {
    return `${this.getApiServerUrl()}/images/${guid}?size=${size}`;
  }
}
